<template>
  <div>
    <input type="text" v-model="new_psd" class="input ignore-password-input" ref="input" maxlength="6" />
    <header>
      <h2 class="title">{{ title }}</h2>
      <p class="info">{{ info }}</p>
    </header>
    <article>
      <ul class="flex flex-center" @click="focus">
        <li v-for="val in arr" class="rect flex flex-middle flex-center" :class="{ active: val.fill }" :key="val.id">
        </li>
      </ul>
      <p v-show="err" class="error">
        <i class="el-icon-error"></i>
        {{ errText }}
      </p>
    </article>
  </div>
</template>
<script>
import des from "@/tools/libs/standard-des";

export default {
  data () {
    return {
      new_psd: "",
      arr: [],
      err: false,
      errText: "密码错误，请重新输入",
    };
  },
  created () {
    this.arr = [
      { fill: false, id: 0 },
      { fill: false, id: 1 },
      { fill: false, id: 2 },
      { fill: false, id: 3 },
      { fill: false, id: 4 },
      { fill: false, id: 5 }
    ];
  },
  mounted () {
    let that = this;
    this.$refs.input.focus();
    this.$nextTick(() => {
      that.$emit("success", false);
    });
  },
  props: {
    title: "",
    pwd: "",
    info: "",
    CUST_CODE: "",
    scope: {
      type: String,
      default: "1"//1资金密码 3信用资金密码
    },
    isSecondCheck: false
  },
  methods: {
    checkPassWord (password) {

      this.myLoading({
        loadingText: "检验中，请稍候",
        icon_type: "loading"
      });
      if (this.isSecondCheck) {
        if (this.pwd === this.new_psd) {
          this.err = false;
          this.$emit("success", true);
        } else {
          this.err = true;
          this.errText = "密码输入不一致，请重新输入";
          this.new_psd = "";
          this.$emit("success", false);
        }
        this.myLoading({ showLoading: false });
      } else {
        return this.$syscfg.K_Request("F0000000", {
          SERVICE_CODE: "Y3000201",
          USE_SCOPE: this.scope,
          CUST_CODE: this.CUST_CODE,
          // F_CUST_ORG_CODE: paramObj.INT_ORG || "",
          PASSWORD: des.encrypt(password, this.CUST_CODE)
        }, true).then(res => {
          this.myLoading({ showLoading: false });
          consoleLog("成功");
          this.$emit("success", true, des.encrypt(password, this.CUST_CODE));
          this.err = false;
        }).catch(err => {
          this.myLoading({ showLoading: false });
          consoleLog("失败");
          this.err = true;
          this.new_psd = "";
        });
      }
    },
    focus (e) {
      this.$refs.input.focus();
    }
  },
  watch: {
    new_psd (val) {
      let len = val.length;
      this.arr.forEach((val, i) => {
        if (i < len) {
          this.arr[i].fill = true;
        } else {
          this.arr[i].fill = false;
        }
      });

      if (len === 6) {
        this.checkPassWord(val);
      } else {
        this.$emit("success", false);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.title {
  font-size: 40px;
  color: #232323;
}
.info {
  margin-top: 24px;
  font-size: 24px;
  color: #81848c;
}
.rect {
  width: 94px;
  height: 99px;
  margin-top: 48px;
  background-image: url("~@img/flow_reuse/dialog/xinxikuang.png");
  background-size: 100% auto;

  &.active::after {
    content: " ";
    display: block;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: black;
  }
}
.error {
  color: #e82d2d;
  font-size: 18px;
}
.el-icon-error {
  margin-right: 10px;
}
.input {
  width: 1px;
  height: 1px;
  border: none;
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/lib/ui/default/message/src/content/password.vue